import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { ModalState, ModalStateList } from 'records/ModalState';

export interface ModalActions {
  createModal: (
    actionParams: AppStateActionParams,
    modalState: ModalState
  ) => AppState;

  replaceModal: (
    actionParams: AppStateActionParams,
    modalState: ModalState
  ) => AppState;

  clearAllModals: (actionsParams: AppStateActionParams) => AppState;
  popModal: (actionParams: AppStateActionParams) => AppState;
}

const modalActions = {
  createModal: (
    { state }: AppStateActionParams,
    modalState: ModalState
  ): AppState => {
    return state().update(
      'modals',
      (modals): ModalStateList => modals.push(modalState)
    );
  },

  replaceModal: (
    { state }: AppStateActionParams,
    modalState: ModalState
  ): AppState => {
    const index = state().modals.findIndex(
      (m) => m.portal === modalState.portal
    );
    return state().update(
      'modals',
      (modals): ModalStateList => modals.set(index, modalState)
    );
  },

  clearAllModals: ({ state }: AppStateActionParams): AppState => {
    return state().set('modals', Immutable.List());
  },

  popModal: ({ state }: AppStateActionParams): AppState => {
    return state().update('modals', (modals): ModalStateList => modals.pop());
  },
};

export default modalActions;
